// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ____   ____    .__   __
 * \\   \\ /   /___ |  |_/  |______      ____ ___.__.
 *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |
 *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |
 *    \\___/ \\____/|____/__| (____  /\\___  // ____|
 *                               \\//_____/ \\/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.shimmer-red {
  background: linear-gradient(
    90deg,
    rgba(239, 68, 68, 1) 0%,
    rgba(248, 113, 113, 1) 50%,
    rgba(239, 68, 68, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-yellow {
  background: linear-gradient(
    90deg,
    rgba(234, 179, 8, 1) 0%,
    rgba(250, 204, 21, 1) 50%,
    rgba(234, 179, 8, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-blue {
  background: linear-gradient(
    90deg,
    rgba(59, 130, 246, 1) 0%,
    rgba(96, 165, 250, 1) 50%,
    rgba(59, 130, 246, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-purple {
  background: linear-gradient(
    90deg,
    rgba(168, 85, 247, 1) 0%,
    rgba(192, 132, 252, 1) 50%,
    rgba(168, 85, 247, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-indigo {
  background: linear-gradient(
    90deg,
    rgba(99, 102, 241, 1) 0%,
    rgba(129, 140, 248, 1) 50%,
    rgba(99, 102, 241, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-teal {
  background: linear-gradient(
    90deg,
    rgba(20, 184, 166, 1) 0%,
    rgba(45, 212, 191, 1) 50%,
    rgba(20, 184, 166, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-green {
  background: linear-gradient(
    90deg,
    rgba(34, 197, 94, 1) 0%,
    rgba(74, 222, 128, 1) 50%,
    rgba(34, 197, 94, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Dark mode shimmers */
.dark .shimmer-green {
  background: linear-gradient(
    90deg,
    rgba(21, 128, 61, 1) 0%,
    rgba(34, 197, 94, 1) 50%,
    rgba(21, 128, 61, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-red {
  background: linear-gradient(
    90deg,
    rgba(185, 28, 28, 1) 0%,
    rgba(239, 68, 68, 1) 50%,
    rgba(185, 28, 28, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-yellow {
  background: linear-gradient(
    90deg,
    rgba(180, 83, 9, 1) 0%,
    rgba(234, 179, 8, 1) 50%,
    rgba(180, 83, 9, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-blue {
  background: linear-gradient(
    90deg,
    rgba(30, 64, 175, 1) 0%,
    rgba(59, 130, 246, 1) 50%,
    rgba(30, 64, 175, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-purple {
  background: linear-gradient(
    90deg,
    rgba(126, 34, 206, 1) 0%,
    rgba(168, 85, 247, 1) 50%,
    rgba(126, 34, 206, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-indigo {
  background: linear-gradient(
    90deg,
    rgba(67, 56, 202, 1) 0%,
    rgba(99, 102, 241, 1) 50%,
    rgba(67, 56, 202, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.dark .shimmer-teal {
  background: linear-gradient(
    90deg,
    rgba(15, 118, 110, 1) 0%,
    rgba(20, 184, 166, 1) 50%,
    rgba(15, 118, 110, 1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* OG light green shimmer for SyncInfo */
.shimmer {
  background: linear-gradient(
    90deg,
    rgba(22, 163, 74, 0) 0%,
    rgba(22, 163, 74, 0.2) 35%,
    rgba(22, 163, 74, 0.5) 50%,
    rgba(22, 163, 74, 0.2) 65%,
    rgba(22, 163, 74, 0) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

/* Special Black/Gold Shimmer for Passkey Login */
@keyframes shimmer-gold {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.shimmer-gold-metal {
  background: linear-gradient(
    to right,
    #462523 0,
    #cb9b51 22%,
    #f6e27a 45%,
    #f6f2c0 50%,
    #f6e27a 55%,
    #cb9b51 78%,
    #462523 100%
  );
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-size: 1000px 100%;
  animation: shimmer-gold 6s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

.animate-fade-in-out {
  animation: fadeInOut 1.5s ease-in-out;
}

.animate-marquee {
  animation: marquee 30s linear infinite;
}

.hover\\:animation-play-state-paused:hover {
  animation-play-state: paused;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes statusPulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.network-status-pulse {
  animation: statusPulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  will-change: transform;
}

@keyframes loadingPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

.loading-pulse {
  animation: loadingPulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);
}

@keyframes notification-pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);
  }

  50% {
    transform: scale(1.1);
    box-shadow: 0 0 0 5px rgba(220, 38, 38, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
  }
}

.animate-notification-shake {
  animation: notification-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-name: notification-pulse !important;
  transform-origin: center center !important;
  position: relative;
  animation-delay: 0s !important;
  will-change: transform, box-shadow;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/animations.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAEF;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE;;;;;;;GAOC;EACD,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,iDAAiD;AACjD;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;;;;;;;;GASC;EACD,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA;EACE,sEAAsE;EACtE,6CAA6C;EAC7C,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC","sourcesContent":["/*\n * ____   ____    .__   __\n * \\   \\ /   /___ |  |_/  |______      ____ ___.__.\n *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |\n *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |\n *    \\___/ \\____/|____/__| (____  /\\___  // ____|\n *                               \\//_____/ \\/\n *\n * Copyright (c) 2017-2025 Voltagy. All rights reserved.\n * https://voltagy.com\n *\n * PROPRIETARY AND CONFIDENTIAL\n *\n * This source code is the proprietary and confidential property of Voltagy.\n * Unauthorized copying, transfer, or use of this file, via any medium, is\n * strictly prohibited without the express written permission of Voltagy.\n *\n * The receipt or possession of this source code and/or related information\n * does not convey or imply any right to use it, reproduce it, disclose its\n * contents, or to manufacture, use, or sell anything that it may describe.\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE\n * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE\n * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\n * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF\n * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS\n * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN\n * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)\n * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE\n * POSSIBILITY OF SUCH DAMAGE.\n *\n */\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.shimmer-red {\n  background: linear-gradient(\n    90deg,\n    rgba(239, 68, 68, 1) 0%,\n    rgba(248, 113, 113, 1) 50%,\n    rgba(239, 68, 68, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-yellow {\n  background: linear-gradient(\n    90deg,\n    rgba(234, 179, 8, 1) 0%,\n    rgba(250, 204, 21, 1) 50%,\n    rgba(234, 179, 8, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-blue {\n  background: linear-gradient(\n    90deg,\n    rgba(59, 130, 246, 1) 0%,\n    rgba(96, 165, 250, 1) 50%,\n    rgba(59, 130, 246, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-purple {\n  background: linear-gradient(\n    90deg,\n    rgba(168, 85, 247, 1) 0%,\n    rgba(192, 132, 252, 1) 50%,\n    rgba(168, 85, 247, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-indigo {\n  background: linear-gradient(\n    90deg,\n    rgba(99, 102, 241, 1) 0%,\n    rgba(129, 140, 248, 1) 50%,\n    rgba(99, 102, 241, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-teal {\n  background: linear-gradient(\n    90deg,\n    rgba(20, 184, 166, 1) 0%,\n    rgba(45, 212, 191, 1) 50%,\n    rgba(20, 184, 166, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.shimmer-green {\n  background: linear-gradient(\n    90deg,\n    rgba(34, 197, 94, 1) 0%,\n    rgba(74, 222, 128, 1) 50%,\n    rgba(34, 197, 94, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n/* Dark mode shimmers */\n.dark .shimmer-green {\n  background: linear-gradient(\n    90deg,\n    rgba(21, 128, 61, 1) 0%,\n    rgba(34, 197, 94, 1) 50%,\n    rgba(21, 128, 61, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-red {\n  background: linear-gradient(\n    90deg,\n    rgba(185, 28, 28, 1) 0%,\n    rgba(239, 68, 68, 1) 50%,\n    rgba(185, 28, 28, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-yellow {\n  background: linear-gradient(\n    90deg,\n    rgba(180, 83, 9, 1) 0%,\n    rgba(234, 179, 8, 1) 50%,\n    rgba(180, 83, 9, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-blue {\n  background: linear-gradient(\n    90deg,\n    rgba(30, 64, 175, 1) 0%,\n    rgba(59, 130, 246, 1) 50%,\n    rgba(30, 64, 175, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-purple {\n  background: linear-gradient(\n    90deg,\n    rgba(126, 34, 206, 1) 0%,\n    rgba(168, 85, 247, 1) 50%,\n    rgba(126, 34, 206, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-indigo {\n  background: linear-gradient(\n    90deg,\n    rgba(67, 56, 202, 1) 0%,\n    rgba(99, 102, 241, 1) 50%,\n    rgba(67, 56, 202, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.dark .shimmer-teal {\n  background: linear-gradient(\n    90deg,\n    rgba(15, 118, 110, 1) 0%,\n    rgba(20, 184, 166, 1) 50%,\n    rgba(15, 118, 110, 1) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n/* OG light green shimmer for SyncInfo */\n.shimmer {\n  background: linear-gradient(\n    90deg,\n    rgba(22, 163, 74, 0) 0%,\n    rgba(22, 163, 74, 0.2) 35%,\n    rgba(22, 163, 74, 0.5) 50%,\n    rgba(22, 163, 74, 0.2) 65%,\n    rgba(22, 163, 74, 0) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 3s infinite;\n}\n\n/* Special Black/Gold Shimmer for Passkey Login */\n@keyframes shimmer-gold {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n.shimmer-gold-metal {\n  background: linear-gradient(\n    to right,\n    #462523 0,\n    #cb9b51 22%,\n    #f6e27a 45%,\n    #f6f2c0 50%,\n    #f6e27a 55%,\n    #cb9b51 78%,\n    #462523 100%\n  );\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  background-size: 1000px 100%;\n  animation: shimmer-gold 6s linear infinite;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@keyframes fadeInOut {\n  0%,\n  100% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.animate-fade-in-out {\n  animation: fadeInOut 1.5s ease-in-out;\n}\n\n.animate-marquee {\n  animation: marquee 30s linear infinite;\n}\n\n.hover\\:animation-play-state-paused:hover {\n  animation-play-state: paused;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes statusPulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);\n  }\n\n  70% {\n    transform: scale(1.1);\n    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n\n.network-status-pulse {\n  animation: statusPulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  will-change: transform;\n}\n\n@keyframes loadingPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);\n  }\n}\n\n.loading-pulse {\n  animation: loadingPulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);\n}\n\n@keyframes notification-pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);\n  }\n\n  50% {\n    transform: scale(1.1);\n    box-shadow: 0 0 0 5px rgba(220, 38, 38, 0);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);\n  }\n}\n\n.animate-notification-shake {\n  animation: notification-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  animation-name: notification-pulse !important;\n  transform-origin: center center !important;\n  position: relative;\n  animation-delay: 0s !important;\n  will-change: transform, box-shadow;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
